/*
 *
 *  *****************************************************************************
 *  *  This material is the confidential, proprietary, unpublished property
 *  *  of Jonas Collections & Recovery.  Receipt or possession of this material
 *  *  does not convey rights to divulge, reproduce, use, or allow others
 *  *  to use it without the specific written authorization of Jonas Collections  & Recovery
 *  *  and use must conform strictly to the license agreement.
 *  *
 *  *  Copyright (c) 2021 Jonas Collections & Recovery.  All rights reserved.
 *  *****************************************************************************
 * /
 *
 */
import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";


@Injectable()
export class OktaAuthGuard implements CanActivate {
	constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth, private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean|UrlTree> {
		return this.oktaAuth.isAuthenticated().then((isAuthenticated) => {
			if (isAuthenticated && this.oktaAuth.getAccessToken()) {
				return true;
			}
			return this.router.parseUrl('/login');
		});
	}
}
